import { render, staticRenderFns } from "./participantGroup.vue?vue&type=template&id=1ec65ba7&"
import script from "./participantGroup.vue?vue&type=script&lang=js&"
export * from "./participantGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports